import { KendoBaseComponent } from '@progress/kendo-base-components-vue-wrapper'
import ButtonProps from './ButtonProps'


export default {
    props: ButtonProps,
    render (h) {
        return h('button',this.$slots.default)
    },
    mixins: [
        KendoBaseComponent
    ],
    mounted() {
        kendo.jQuery(this.$el).kendoButton(this.widgetOptions)

        this.$emit('kendowidgetready', this.kendoWidget())
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoButton()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-buttons-vue-wrapper/src/KendoButton/KendoButtonMixin.js